import { resolveE2eMediaUrl } from './e2eMedia';

const MASK_KEY_ALIASES = {
  UnevenSkin: ['uneven_skintone', 'uneven_skin', 'unevenskin', 'uneven_skintone'],
  'Uneven Skintone': ['uneven_skintone'],
  Hydration: ['hydration'],
  Oxygen: ['oxygen'],
  Smoothness: ['smoothness'],
  Dullness: ['dullness'],
};

export function getSkinConditionKeyCandidates(conditionName) {
  const raw = String(conditionName || '').trim();
  if (!raw) return [];

  const underscored = raw.toLowerCase().replace(/\s+/g, '_');
  const compact = raw.toLowerCase().replace(/[\s_-]+/g, '');
  const candidates = [underscored, compact, raw];

  if (
    compact === 'unevenskin'
    || compact === 'unevenskintone'
    || compact === 'uneventone'
  ) {
    candidates.unshift('uneven_skintone');
  }

  return Array.from(new Set(candidates));
}

export function resolveVisualMaskUrl(masks = {}, selectedConcern) {
  if (!masks || !selectedConcern) return null;

  const keys = [
    ...(MASK_KEY_ALIASES[selectedConcern] || []),
    ...getSkinConditionKeyCandidates(selectedConcern),
    String(selectedConcern).toLowerCase().replace(/\s+/g, '_'),
  ];

  const unique = Array.from(new Set(keys));
  for (const key of unique) {
    const val = masks[key];
    const resolved = resolveE2eMediaUrl(val);
    if (resolved) return resolved;
  }

  const target = String(selectedConcern || '').toLowerCase().replace(/[\s_-]+/g, '');
  const aliases = new Set([target]);
  if (target === 'unevenskin' || target === 'unevenskintone' || target === 'uneventone') {
    aliases.add('unevenskintone');
    aliases.add('unevenskin');
  }

  for (const [key, val] of Object.entries(masks)) {
    const norm = String(key).toLowerCase().replace(/[\s_-]+/g, '');
    if (aliases.has(norm)) {
      const resolved = resolveE2eMediaUrl(val);
      if (resolved) return resolved;
    }
  }

  return null;
}
